{
  "name": "pozi-kliens",
  "version": "1.5.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-hu": "ng serve --configuration hu",
    "start-deckers": "ng serve --configuration deckers",
    "start-local": "ng serve --configuration local",
    "build": "ng build",
    "test": "ng test --watch=false",
    "lint": "ng lint",
    "e2e": "playwright test",
    "prod-build": "ng build --configuration production",
    "test-build": "ng build --configuration test",
    "xi18n": "ng extract-i18n",
    "todo:check": "node scripts/validate-todo.mjs",
    "tools:test": "node scripts/validate-todo.mjs && node scripts/validate-todo.test.mjs"
  },
  "private": true,
  "dependencies": {
    "@amcharts/amcharts4": "^4.10.34",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/localize": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@innobile/alertsmodule": "latest",
    "@innobile/authmodule": "latest",
    "@innobile/tablemodule": "latest",
    "angular-oauth2-oidc": "^21.0.3",
    "leaflet": "^1.9.3",
    "leaflet-hotline": "^0.4.0",
    "lodash-es": "^4.17.21",
    "luxon": "^3.3.0",
    "material-icons": "^1.13.2",
    "material-symbols": "^0.45.10",
    "moment": "^2.29.4",
    "ng-inline-svg": "^13.1.2",
    "roboto-fontface": "^0.10.0",
    "rxjs": "^7.8.2",
    "socket.io-client": "2.5.0",
    "tippy.js": "^6.3.7",
    "tslib": "^2.4.0",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular/build": "^21.2.18",
    "@angular/cli": "^21.2.18",
    "@angular/compiler-cli": "^21.2.17",
    "@angular/language-service": "^21.2.17",
    "@playwright/test": "^1.48.0",
    "@types/leaflet": "^1.9.2",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^22.10.0",
    "@types/socket.io-client": "^1.4.36",
    "angular-eslint": "21.4.0",
    "eslint": "^10.0.1",
    "jsdom": "^29.1.1",
    "ng-extract-i18n-merge": "3.4.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.63.0",
    "vitest": "^4.1.10",
    "yaml": "2.9.0",
    "zod": "4.4.2"
  },
  "packageManager": "yarn@3.6.1"
}
